<ng-container *ngIf="observerQ$ | async as operationQ" [xOperation]="operationQ">
  <button
    *ngIf="control$ | async as operation"
    mat-flat-button
    [color]="color"
    [xButtonLoading]="operation.status === 'loading'"
    [xButtonSize]="buttonSizes"
    (click)="recreate(operation)"
    i18n="@@CallToAction.Reorder"
  >
    Reorder
  </button>

  <x-shop-error-operation *xOperationError="let error" [error]="error"></x-shop-error-operation>
</ng-container>
